import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { createTRPCClient, httpLink, retryLink } from '@trpc/client';
var client;
function isFetchError(error) {
  return error instanceof Error && error.name === 'FetchError';
}
function createClient(url, cookieHeaders) {
  if (client) {
    return client;
  }
  return createTRPCClient({
    links: [retryLink({
      retry: function retry(opts) {
        if (opts.error.data && opts.error.data.code !== 'INTERNAL_SERVER_ERROR') {
          // Don't retry on non-500s
          return false;
        }
        if (opts.op.type !== 'query') {
          // Only retry queries
          return false;
        }
        // Retry up to 2 times
        return opts.attempts <= 2;
      }
    }), httpLink({
      url: url + '/trpc',
      headers: function headers() {
        return _objectSpread({}, cookieHeaders);
      },
      fetch: function fetch(input, init) {
        return $fetch.raw(input.toString(), init).catch(function (e) {
          if (isFetchError(e) && e.response) {
            return e.response;
          }
          throw e;
        }).then(function (response) {
          return _objectSpread(_objectSpread({}, response), {}, {
            headers: response.headers,
            json: function json() {
              return Promise.resolve(response._data);
            }
          });
        });
      }
    })]
  });
}
export function useTrpc() {
  var _useRuntimeConfig = useRuntimeConfig(),
    _useRuntimeConfig$pub = _useRuntimeConfig.public,
    middlewareUrlV2 = _useRuntimeConfig$pub.middlewareUrlV2,
    ssrMiddlewareUrlV2 = _useRuntimeConfig$pub.ssrMiddlewareUrlV2;
  var cookieHeaders = {
    cookie: ''
  };
  if (process.server) {
    var _event$context;
    var event = useRequestEvent();
    if ((_event$context = event.context) !== null && _event$context !== void 0 && _event$context.shouldInvalidateCache) {
      cookieHeaders.cookie = 'reset=y';
    }
  }
  var url = process.server ? ssrMiddlewareUrlV2 : middlewareUrlV2;
  client = createClient(url, cookieHeaders);
  return {
    client: client
  };
}